import(/* webpackMode: "eager", webpackExports: ["BlogPost"] */ "/vercel/path0/src/components/blog/blog-post.tsx");
